var map = {
	"./BasemapGallery": 96481,
	"./BasemapGallery.css": 50753,
	"./BasemapGallery.js": 96481,
	"./images/Arabic Dark Gray Web Mercator .png": 70762,
	"./images/Arabic light Gray Geographic.jpg": 69786,
	"./images/Arabic light Gray Web Mercator.png": 24778,
	"./images/Basemap Arabic Dark Gray Geographic coordinates.png": 11058,
	"./images/ESRI Satellite Imagery.png": 8188,
	"./images/ESRI World Imagery.png": 21603,
	"./images/English Dark Gray Geographic.png": 99082,
	"./images/English Dark Gray Web Mercator.png": 73590,
	"./images/English Dark Gray Web Mercator1.png": 94413,
	"./images/English Light Gray Web Mercator.png": 41720,
	"./images/English light Gray Geographic.png": 71072,
	"./images/Landsat_1972.png": 38257,
	"./images/Satellite Imagery.png": 42809,
	"./images/Topo_Eng.png": 23061,
	"./images/topo_Ar.png": 54312
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92512;